import http from "./http";
import { loading, close } from "@alert";
import { apiBaseUrl as baseUrl } from "./apiBaseUrl";
const invoice_baseUrl = "https://api.ezreceipt.cc";
const try_invoice_baseUrl = "https://tryapi.ezreceipt.cc";
const testTapPayBaseUrl = "https://sandbox-yms.tappaysdk.com/api/pos";
const tapPayBaseUrl = "https://prod-yms.tappaysdk.com/api/pos";
const corsURL = "https://cors-anywhere.herokuapp.com/";
const localBaseUrl = "http://localhost:1943/";

const request = async (method, url, token, data = null, options = {}) => {
  try {
    const response = await http({
      method,
      url: baseUrl + url,
      data,
      ...options,
      headers: {
        Authorization: "Bearer " + token,
        ...(options.headers || {}),
      },
    });
    return response;
  } catch (err) {
    throw err;
  }
};

const updateRequest = async (method, url, token, data = null, options = {}) => {
  try {
    loading()
    const response = await http({
      method,
      url: baseUrl + url,
      data,
      ...options,
      headers: {
        Authorization: "Bearer " + token,
        ...(options.headers || {}),
      },
    });
    close();
    return response;
  } catch (err) {
    close();
    throw err;

  }
};


export {
  baseUrl,
  invoice_baseUrl,
  try_invoice_baseUrl,
  testTapPayBaseUrl,
  tapPayBaseUrl,
  corsURL,
  request,
  updateRequest,
  localBaseUrl,
};
